import React from 'react';
import SubHeaderComponent from '../../../components/header/subheader';
import "../../../assets/css/common/AllCss.css";

export default  class NotFind extends React.Component {
	componentDidMount(props) {
		
	}
	componentWillUnmount(){
    	//界面离开的时候
		this.setState = (state, callback)=>{
			return;
		}
	}
	render() {
		return(
			<div className={'NotFind'}>
				<SubHeaderComponent title="正在开发中"></SubHeaderComponent>
				<div>
					<img src={require('../../../assets/images/video/kaif1.png')} className={'NotFind-img1'} />
					<img src={require('../../../assets/images/video/kaif2.png')} className={'NotFind-img2'} />
					<img src={require('../../../assets/images/video/kaif3.png')} className={'NotFind-img3'} />
					<img src={require('../../../assets/images/video/kaif4.png')} className={'NotFind-img4'} />
				</div>
		    </div>
		);
	}
}